import React from 'react'
import { Link, Element , Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import { BrowserView, MobileView, isBrowser, isMobile } from "react-device-detect";
import NavigationPrompt from "react-router-navigation-prompt";

import { Button } from 'react-bootstrap'
import Dialog from 'react-bootstrap-dialog'
import _ from 'lodash'


class WizardStepBase extends React.Component{
  constructor(props) {
    super(props);
  }

  validateState() {
    let errors = this.getStepErrors();
    if (!this.props.order_state.groups.construction.items.length && this.props.location.pathname != '/') {
      this.props.history.push('/');
      return;
    }

    return errors && errors.length;
  }

  get isFactoryStandartSelected() {
    const isCustomSize = _.get(this.props.order_state.groups, 'size.selected') == 'CUSTOM_SIZE';

    return !isCustomSize;
  }

  componentDidMount() {
    this.props.order_actions.validateStep();

  }

  canLetGo(curPath, nextPath) {
    if (nextPath == '/') { return true }
    let
      curStepHash = curPath.split('-'),
      nextStepHash = nextPath.split('-'),
      currentStep = curStepHash[1],
      nextStep = nextStepHash[1];

    if (curStepHash[0] == '/step' && nextStepHash[0] == '/step' && currentStep > nextStep) {
      return true;
    }
    return false;
  }

  getStepErrors() {
    return this.props.order_state.errors[`step-${this.stepNum}`];
  }

  hideHints() {
    this.props.order_actions.hideHint();
  }

  setErrorsToChain() {
    this.props.order_actions.addToActionsChain(this.getStepErrors().map(item => Object.keys(item)[0]));
  }

  renderConfirm () {
    const hint = this.props.order_state.hint;
    return (
      <div>
        <NavigationPrompt when={(crntLocation, nextLocation) => {
            return !this.canLetGo(crntLocation.pathname, nextLocation.pathname) && this.validateState()
          }
        }>
          {({ onConfirm, onCancel }) => {
            this.dialog.show({
              body: (
                <div className="errors-popup">
                  { this.getStepErrors().map(item => item[Object.keys(item)[0]]).join('\n') }
                </div>
              ),
              bsSize: 'lg',
              actions: [
                Dialog.OKAction(() => {
                  this.setErrorsToChain();
                  onCancel();
                })
              ]
            });
          }}
        </NavigationPrompt>
        <Dialog className="errors-dialog" ref={(el) => { this.dialog = el }} />
        { hint && !isMobile ? (
          <div className="global-hint" style={{
            left: hint.x,
            top: hint.y
          }}>
            { hint.text }
          </div>
        ) : null }
      </div>
    )
  }

  stepChange = (e) => {
    if (isMobile) {
      setTimeout(() => {
        let y = document.getElementById('js-page-content-top').getBoundingClientRect().y + window.scrollY;
        scroll.scrollTo(y, {
          duration: 200
        });
      }, 10);
      this.setState({
        menuOpened: false
      });
    }
  }
}

export default WizardStepBase;



// WEBPACK FOOTER //
// ./app/javascript/app/pages/wizard_steps/base.jsx